import {ContainerListItem} from "../dto/com.rico.sb2.service.queue";
import {BindingList, createHtmlElement, setInnerTextAndTitle} from "../lib/domFunctions";
import {ContainerType} from "../dto/com.rico.sb2.entity.detail";
import {coalesce} from "../lib/coalesce";
import {AppConfig} from "../AppConfig";
import {SinglePopover} from "../lib/bootstrapPopover";
import {FinishedClickMenu} from "./FinishedClickMenu";

const TEMPLATE = `
<span class="d-inline-flex align-items-center gap-1 flex-shrink-0">
	<span class="text-nowrap" data-bind="number"></span>
</span>
<img src="" alt="" data-bind="icon">
<div class="container-row-widget__main text-nowrap">
    <span class="d-block overflow-hidden overflow-ellipsis" data-bind="process"></span>
    <span class="d-block overflow-hidden overflow-ellipsis" data-bind="coating"></span>
</div>
<div class="container-row-widget__info">
    <div data-bind="status"></div>
    <div data-bind="finishTime"></div>
</div>
`;

export class FinishedListItem {
	readonly data: ContainerListItem
	readonly element: HTMLDivElement;

	private readonly bindings = new BindingList()

	private clickMenu: FinishedClickMenu | null = null

	constructor(data: ContainerListItem) {
		this.data = data

		this.element = createHtmlElement('div', {role: 'button', tabindex: 0, class: 'container-row-widget container-theme'}, TEMPLATE)
		this.bindings.collect(this.element)

		this.element.addEventListener('click', ev => {
			const menu = this.requireClickMenu()
			const popover = menu.createPopover(this.element);
			SinglePopover.show(this.element, popover, {dispose: true, hidden: () => menu.hidePopover()})
			ev.preventDefault()
		})

		this.update()
	}

	private update() {
		const data = this.data
		this.bindings.update<HTMLAnchorElement>('goto', a => a.href = `${AppConfig.CP}/queue/${data.id}`)

		this.bindings.update('number', node => node.innerText = `${data.id}`)
		this.bindings.update<HTMLImageElement>('icon', node => node.src = `/content/icon.${coalesce(data.type, ContainerType.NOT_DEFINED).toLowerCase()}.svg`)

		this.bindings.update('process', node => setInnerTextAndTitle(node, coalesce(data.processCode, '')))
		this.bindings.update('coating', node => setInnerTextAndTitle(node, coalesce(data.coating, '')))

		this.bindings.update('status', node => node.innerText = data.reportStatus || '')
		this.bindings.update('finishTime', node => node.innerText = data.finishDate ? data.finishDate : '')
	}

	private requireClickMenu() {
		if (this.clickMenu == null) {
			this.clickMenu = new FinishedClickMenu(this.data);
		}
		return this.clickMenu;
	}
}